var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastMessagePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B1B1B3",
    d: "M2 0h4.586C7.49 0 8.36.36 9 1l1 1 1 1c.64.64 1 1.509 1 2.414V12c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0z",
    transform: "translate(-271 -745) translate(-12 675) translate(283 70)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M6 0v4c0 1.105.895 2 2 2h4",
    transform: "translate(-271 -745) translate(-12 675) translate(283 70)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastMessagePdf);
export default __webpack_public_path__ + "static/media/lastMessagePdf.badbe19134cda38e07a697744f48639e.svg";
export { ForwardRef as ReactComponent };